/**
 * Renders content HTML from the CMS. The server sanitizes on write, so this is
 * the single place trusted markup enters the DOM.
 *
 * The markup is injected directly onto the .prose element rather than into a
 * nested wrapper — Typography's `> :first-child { margin-top: 0 }` only matches
 * a direct child, so a wrapper would leave the first heading with its full 2em
 * top margin and open a large gap under the page title.
 *
 * Tables are set to scroll in their own box so a wide table never pushes the
 * page sideways on a phone.
 */
export default function Prose({ html, className = '' }: { html: string; className?: string }) {
  return (
    <div
      className={`prose prose-lg prose-ink max-w-none prose-headings:font-display prose-p:leading-relaxed prose-p:text-ink-900 prose-li:text-ink-900 prose-strong:text-ink-900 prose-a:font-medium prose-a:text-gold-600 prose-a:no-underline hover:prose-a:text-gold-500 prose-h2:mb-3 prose-h2:mt-10 prose-h2:text-xl prose-h2:font-bold prose-h2:text-gold-600 prose-h3:mb-2 prose-h3:mt-8 prose-h3:text-lg prose-h3:font-bold prose-h3:text-ink-800 prose-h4:mb-2 prose-h4:mt-6 prose-h4:text-lg prose-h4:text-ink-800 [&>*:first-child]:mt-0 [&_table]:block [&_table]:overflow-x-auto ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
